import { Icon, IconName } from "@nju/icons";
import { BlockContent } from "../BlockContent";
import { Text } from "../Text";

interface IAlertProps {
  iconName: IconName;
  text: string | JSX.Element;
  title?: string;
}

export function Alert({ iconName, text, title }: IAlertProps) {
  return (
    <div className="relative border-b-1 border-geyser">
      <div className="h-full pt-4 absolute px-1 from-tablet:px-2 bg-ripeLemon">
        <Icon
          className="only-mobile:hidden"
          height={24}
          name={iconName}
          width={24}
        />
      </div>
      <div className="p-2 from-tablet:px-10 from-tablet:py-4 bg-white">
        {title && (
          <BlockContent>
            <Text
              size={{
                "@onlyMobile": "s",
                "@fromTablet": "m",
              }}
              weight="bold"
            >
              {title}
            </Text>
          </BlockContent>
        )}
        <BlockContent>
          <Text
            size={{
              "@onlyMobile": "s",
              "@fromTablet": "m",
            }}
          >
            {text}
          </Text>
        </BlockContent>
      </div>
    </div>
  );
}
